import type { Workbook, Worksheet } from "exceljs";
import { EXCEL_TYPE } from "./constant";

export const set = (ws: Worksheet) => {
  const date = new Date();
  const template = (cr: string) => {
    return {
      header: {
        /**
         * TCT HÀNG KHÔNG VIỆT NAM
         */
        h1: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "TCT HÀNG KHÔNG VIỆT NAM";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman" };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * CÔNG TY DVMĐ SÂN BAY VIỆT NAM
         */
        h2: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
         */
        h3: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * Độc lập - Tự do - Hạnh phúc
         */
        h4: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "Độc lập - Tự do - Hạnh phúc";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true};
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
      },
      title: {
        /**
         * DANH SÁCH CBNV VIAGS TÂN SƠN NHẤT ĐỀ NGHỊ CẤP THẺ KIỂM SOÁT AN NINH HÀNG KHÔNG, SÂN BAY CÓ GIÁ TRỊ SỬ DỤNG DÀI HẠN
         */
        t1: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value =
            "DANH SÁCH NHÂN VIÊN VIAGS ĐỀ NGHỊ CẤP THẺ KSAN CÓ GIÁ TRỊ SỬ DỤNG DÀI HẠN";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        },
        /**
         * (Kèm theo Công văn số              /VIAGS-VP, ngày       /09/ 2023, của  Công ty Dịch vụ Mặt đất Sân bay Việt Nam)
         */
        t2: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = `(Kèm theo Công văn số              /VIAGS-VPCT, ngày       /${
            date.getMonth() + 1
          }/ ${date.getFullYear()}, của Công ty Dịch vụ Mặt đất Sân bay Việt Nam`;
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", italic: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        t2sub: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = ` Công ty Dịch vụ Mặt đất Sân bay Việt Nam)`;
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", italic: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * DANH SÁCH NHÂN VIÊN $1 ĐỀ NGHỊ CẤP THẺ KSAN NGẮN HẠN
         */
        t3: (unit: string[]) => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = `DANH SÁCH NHÂN VIÊN VIAGS ĐỀ NGHỊ CẤP THẺ KSAN CÓ GIÁ TRỊ SỬ DỤNG NGẮN HẠN`;
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        },
        /**
         * (Kèm theo Công văn số            /VIAGS-VP ngày          /     / 2023 của Công ty Dịch vụ Mặt đất Sân bay Việt Nam)
         */
        t4: () => {
          ws.mergeCells(cr);
          ws.getCell(
            cr,
          ).value = `(Kèm theo Công văn số            /VIAGS-VPCT ngày          /     /${date.getFullYear()}  của Công ty Dịch vụ Mặt đất Sân bay Việt Nam`;
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", italic: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        t4sub: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = ` Công ty Dịch vụ Mặt đất Sân bay Việt Nam)`;
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", italic: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
      },
      footer: {
        /**
         * T/L TỔNG GIÁM ĐỐC
         */
        f1: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "T/L TỔNG GIÁM ĐỐC";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * CHÁNH VĂN PHÒNG CÔNG TY
         */
        f2: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "CHÁNH VĂN PHÒNG CÔNG TY";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
        /**
         * Trần Đức Hiệp
         */
        f3: () => {
          ws.mergeCells(cr);
          ws.getCell(cr).value = "Trần Đức Hiệp";
          ws.getCell(cr).style.font = { size: 13, name: "Times New Roman", bold: true };
          ws.getCell(cr).alignment = { horizontal: "center", vertical: "middle" };
        },
      },
    };
  };

  const cell = (cr: string) => template(cr);

  return { cell };
};

export const saveBlob = async (wb: Workbook) => {
  const buffer = await wb.xlsx.writeBuffer();

  return new Blob([buffer], { type: EXCEL_TYPE });
};
